
import { Component } from 'react'
import { Col, Row } from 'reactstrap'
import TableColumnPreferenceControl from '../../Material/TableColumnPreferenceControl'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import CreateUpdateTPAModal from '../Modals/CreateUpdateTPAModal'


class TPAActions extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
        }
    }

    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName })
    }

    render() {
        return (
            <Row>
                <Col xs={12} className="text-right mt-3">
                    <TableColumnPreferenceControl
                        tableId={this.props.tableId}
                        columnConfig={this.props.columnConfig}
                        setColumnConfig={this.props.setColumnConfig}
                        defaultColumnConfig={this.props.defaultColumnConfig}
                    />&nbsp;&nbsp;&nbsp;
                    <a id="createNewTpa" className="driver-list-button" onClick={() => this.toggleModal("createNewTpa")}>
                        CREATE | <i className="fa fa-plus" aria-hidden="true"></i>
                    </a>&nbsp;&nbsp;&nbsp;
                    {this.state.openModal === "createNewTpa" &&
                        <CreateUpdateTPAModal
                            isOpen={this.state.openModal === "createNewTpa"}
                            toggle={() => this.toggleModal("")}
                            refetchQuery={this.props.refetchQuery}
                        />}
                </Col>
            </Row>
        )
    }
}


export default (TPAActions)
